import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Card, CardContent } from './components/ui/card'
import { Button } from './components/ui/button'

const About = () => {
    const { t } = useTranslation()

    return (
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 space-y-24">
            {/* Hero section */}
            <section className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                    <h2 className="text-3xl font-bold tracking-tight">{t('about.unlockTitle')}</h2>
                    <p className="mt-4 text-muted-foreground leading-relaxed">{t('about.unlockText')}</p>
                </div>
                <div className="rounded-lg overflow-hidden">
                    <img src="/assets/new_opportunity.jpg" alt="" className="w-full h-auto object-cover" />
                </div>
            </section>

            {/* Features grid */}
            <section className="grid md:grid-cols-2 gap-8">
                <Card className="border-l-4 border-l-primary">
                    <CardContent className="p-6">
                        <h3 className="text-xl font-semibold">{t('about.optimizedTitle')}</h3>
                        <img src="/assets/complex_code.jpg" alt="" className="mt-4 w-full rounded-md object-cover" />
                        <p className="mt-4 text-muted-foreground leading-relaxed">{t('about.optimizedText')}</p>
                    </CardContent>
                </Card>
                <Card className="border-l-4 border-l-primary">
                    <CardContent className="p-6">
                        <h3 className="text-xl font-semibold">{t('about.scaleTitle')}</h3>
                        <img src="/assets/scale.jpg" alt="" className="mt-4 w-full rounded-md object-cover" />
                        <p className="mt-4 text-muted-foreground leading-relaxed">{t('about.scaleText')}</p>
                    </CardContent>
                </Card>
            </section>

            <section className="grid md:grid-cols-2 gap-8">
                <Card className="border-l-4 border-l-primary">
                    <CardContent className="p-6">
                        <h3 className="text-xl font-semibold">{t('about.simpleTitle')}</h3>
                        <img src="/assets/simplicity.jpg" alt="" className="mt-4 w-full rounded-md object-cover" />
                        <p className="mt-4 text-muted-foreground leading-relaxed">{t('about.simpleText')}</p>
                    </CardContent>
                </Card>
                <Card className="border-l-4 border-l-primary">
                    <CardContent className="p-6">
                        <h3 className="text-xl font-semibold">{t('about.availabilityTitle')}</h3>
                        <img src="/assets/availability.jpg" alt="" className="mt-4 w-full rounded-md object-cover" />
                        <p className="mt-4 text-muted-foreground leading-relaxed">{t('about.availabilityText')}</p>
                        <div className="mt-6">
                            <Link to="/contact">
                                <Button variant="outline">{t('about.learnMore')}</Button>
                            </Link>
                        </div>
                    </CardContent>
                </Card>
            </section>
        </div>
    )
}

export default About
